import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGrafanaComponent } from './simple-icons-grafana.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGrafanaComponent ],
    exports:      [ SimpleIconsGrafanaComponent ],
    bootstrap:    []
})
export class SimpleIconsGrafanaModule {}
